import React from "react";
import { CreateFormsProps } from "../pages/Requests/CreateRequestPage";
import { FormTypeEnum } from "../api";
import FormView from "../pages/Requests/FormViewPage";
import AssessmentFormComponent from "../pages/Assessment/AssessmentFormComponent";
import LinkedObjectFormComponent from "../pages/LinkedObject/LinkedObjectFormComponent";
import CommentComponent from "./CommentComponent";

interface Props {
  form: CreateFormsProps;
  requestId?: number;
  onSuccess: (result: any) => void;
  readonly?: boolean;
  values?: any;
  duplicateRequestId?: number | undefined;
  setDuplicateRequestId?: (duplicateRequestId: number | undefined) => void;
}

const RenderFormComponent = ({
  form,
  requestId,
  onSuccess,
  duplicateRequestId,
  setDuplicateRequestId,
}: Props) => {
  const renderForm = (type: FormTypeEnum) => {
    console.log(type);
    switch (type) {
      case FormTypeEnum.DYNAMIC:
        return (
          <FormView
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
            system_form_extra_actions={form.system_form_extra_actions}
          />
        );
      case FormTypeEnum.RISK_ASSESSMENT:
        return (
          <AssessmentFormComponent
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
          />
        );
      case FormTypeEnum.LINKED_OBJECT:
        return (
          <LinkedObjectFormComponent
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
          />
        );
      case FormTypeEnum.COMMENT:
        return (
          <CommentComponent
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
          />
        );
      default:
        return null;
    }
  };

  return <>{renderForm(form.formType!)}</>;
};

export default RenderFormComponent;
